"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkedinGetProfiles = exports.linkedinGetProfilesResultSchema = exports.linkedinProfileSchema = exports.linkedinCompanySchema = exports.linkedinUpdateSchema = exports.linkedinReactionTypeCountSchema = exports.linkedinEducationSchema = exports.linkedinExperienceSchema = exports.linkedinGetProfilesArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Args schema
exports.linkedinGetProfilesArgsSchema = zod_1.z.object({
    profileUrls: zod_1.z.array(zod_1.z.string()).describe('Array of LinkedIn profile URLs to fetch'),
});
// Result schema
exports.linkedinExperienceSchema = zod_1.z.object({
    companyId: zod_1.z.string().nullish().describe('Company ID'),
    companyUrn: zod_1.z.string().nullish().describe('Company URN'),
    companyLink: zod_1.z.string().nullish().describe('Company LinkedIn URL'),
    logo: zod_1.z.string().nullish().describe('Company logo URL'),
    title: zod_1.z.string().nullish().describe('Job title'),
    subtitle: zod_1.z.string().nullish().describe('Job subtitle'),
    caption: zod_1.z.string().nullish().describe('Job caption'),
    metadata: zod_1.z.string().nullish().describe('Job metadata'),
});
exports.linkedinEducationSchema = zod_1.z.object({
    companyId: zod_1.z.string().nullish().describe('Institution ID'),
    companyUrn: zod_1.z.string().nullish().describe('Institution URN'),
    companyLink: zod_1.z.string().nullish().describe('Institution LinkedIn URL'),
    logo: zod_1.z.string().nullish().describe('Institution logo URL'),
    title: zod_1.z.string().nullish().describe('Education title'),
    caption: zod_1.z.string().nullish().describe('Education caption'),
});
exports.linkedinReactionTypeCountSchema = zod_1.z.object({
    count: zod_1.z.number().nullish().describe('Number of reactions'),
    reactionType: zod_1.z.string().nullish().describe('Type of reaction'),
});
exports.linkedinUpdateSchema = zod_1.z.object({
    postText: zod_1.z.string().nullish().describe('Post text content'),
    image: zod_1.z.string().nullish().describe('Post image URL'),
    postLink: zod_1.z.string().nullish().describe('Post URL'),
    numLikes: zod_1.z.number().nullish().describe('Number of likes'),
    numComments: zod_1.z.number().nullish().describe('Number of comments'),
    reactionTypeCounts: zod_1.z
        .array(exports.linkedinReactionTypeCountSchema)
        .nullish()
        .describe('Reaction type counts'),
});
exports.linkedinCompanySchema = zod_1.z.object({
    name: zod_1.z.string().nullish().describe('Company name'),
    industry: zod_1.z.string().nullish().describe('Company industry'),
    website: zod_1.z.string().nullish().describe('Company website'),
    linkedinUrl: zod_1.z.string().nullish().describe('Company LinkedIn URL'),
    foundedYear: zod_1.z.number().nullish().describe('Company founded year'),
});
exports.linkedinProfileSchema = zod_1.z.object({
    url: zod_1.z.string().describe('LinkedIn profile URL'),
    username: zod_1.z.string().describe('Profile username'),
    firstName: zod_1.z.string().nullish().describe('First name'),
    lastName: zod_1.z.string().nullish().describe('Last name'),
    fullName: zod_1.z.string().nullish().describe('Full name'),
    headline: zod_1.z.string().nullish().describe('Profile headline'),
    about: zod_1.z.string().nullish().describe('About section'),
    connections: zod_1.z.number().nullish().describe('Number of connections'),
    followers: zod_1.z.number().nullish().describe('Number of followers'),
    email: zod_1.z.string().nullish().describe('Email address'),
    website: zod_1.z.string().nullish().describe('Website URL'),
    mobileNumber: zod_1.z.string().nullish().describe('Mobile number'),
    country: zod_1.z.string().nullish().describe('Country'),
    address: zod_1.z.string().nullish().describe('Address'),
    profilePictureUrl: zod_1.z.string().nullish().describe('Profile picture URL'),
    jobTitle: zod_1.z.string().nullish().describe('Current job title'),
    jobDuration: zod_1.z.string().nullish().describe('Current job duration'),
    jobDurationInYears: zod_1.z.number().nullish().describe('Current job duration in years'),
    company: exports.linkedinCompanySchema.nullish().describe('Current company information'),
    experiences: zod_1.z.array(exports.linkedinExperienceSchema).nullish().describe('Work experiences'),
    educations: zod_1.z.array(exports.linkedinEducationSchema).nullish().describe('Education history'),
    skills: zod_1.z.array(zod_1.z.string()).nullish().describe('Skills list'),
    updates: zod_1.z.array(exports.linkedinUpdateSchema).nullish().describe('Recent updates/posts'),
});
exports.linkedinGetProfilesResultSchema = zod_1.z.object({
    profiles: zod_1.z.array(exports.linkedinProfileSchema).nullish().describe('Array of LinkedIn profiles'),
});
// Tool metadata
exports.linkedinGetProfiles = (0, common_1.createToolMetadata)({
    id: 'linkedinGetProfiles',
    displayName: 'LinkedIn Profile Fetch',
    displayDescription: 'Fetch detailed LinkedIn profiles by profile URLs',
    category: 'social',
    color: common_1.BRAND_COLORS.LINKEDIN,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.LINKEDIN),
    icon: 'linkedin',
    argsSchema: exports.linkedinGetProfilesArgsSchema,
}, exports.linkedinGetProfilesResultSchema);
